import { classForeground as classForegroundColours, inline as inlineColours } from '@modules/colours';

const stateMapClass: Record<string, string> = {
    fail: classForegroundColours('red'),
    notApplicable: classForegroundColours('blue'),
    pass: classForegroundColours('green'),
    warning: classForegroundColours('orange')
};

const stateMapInline: Record<string, string> = {
    fail: inlineColours('red'),
    notApplicable: inlineColours('blue'),
    pass: inlineColours('green'),
    warning: inlineColours('orange')
};

const map = (name: string, stateMap: Record<string, string>): string => {
    if (!name) throw new Error('State name is required');
    if (!stateMap[name]) throw new Error(`State '${name}' not found`);

    return stateMap[name];
};

export function classForeground(name: string): string {
    return map(name, stateMapClass);
}

export function inline(name: string): string {
    return map(name, stateMapInline);
}
